import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { LandingPage } from './components/LandingPage.js';
import { Form } from './components/Form.js';
import { Success } from './components/Success.js';
import './index.css';

function App() {
  return (
    <div>
      <Routes>
        <Route index element={<LandingPage />} />
        <Route path='/form' element={<Form />} />
        <Route path='/success' element={<Success />} />
        <Route path='*' element={<Navigate to='/' />} />
      </Routes>
    </div>
  );
}

export default App;
